import {User} from './user-interfaces';
import {Group} from './group-interfaces';
import {UserEntityType} from '@app/shared/services/api/user-entity';

export interface Permission {
  id: PermissionId;
  type: UserEntityType;
  entity_id: number;
  nameKey?: string;
  users?: User[];
  groups?: Group[];
}

export enum GlobalPermissionId {
  PLATFORM_ADMIN = 'platform-admin',
  RESOURCE_SHARER = 'resource-sharer',
  LICENSER = "licenser"
}

export enum PermissionId {
  CUSTOMER_ADMIN = 'customer-admin',
  CUSTOMER_CLIENT_ADMIN = 'customer-client-admin',
  CLIENT_ADMIN = 'client-admin',
}

export enum PermissionTarget {
  USER = 'user',
  GROUP = 'group',
}



